import { render, staticRenderFns } from "./add_book_periodicals.vue?vue&type=template&id=4da4d5c7&scoped=true&"
import script from "./add_book_periodicals.vue?vue&type=script&lang=js&"
export * from "./add_book_periodicals.vue?vue&type=script&lang=js&"
import style0 from "./add_book_periodicals.vue?vue&type=style&index=0&id=4da4d5c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da4d5c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBreadcrumbs,VCard,VCardTitle,VCol,VImg,VRow,VTextField})
